import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { isAuthorizedGoogleAccount } from '../utils/config';

const SignIn = () => {
  const navigate = useNavigate();
  const { login, initializeAuth } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleGoogleSuccess = async (response) => {
    setIsLoading(true);
    setError(null);

    const token = response.credential;

    try {
      const decodedData = jwtDecode(token);

      if (!isAuthorizedGoogleAccount(decodedData.hd, decodedData.email)) {
        setError('Solo se permiten cuentas corporativas de @xinerlink.cl o @valorate.cl');
        return;
      }

      await login(token, decodedData);
      await initializeAuth();
      navigate('/', { replace: true });
    } catch (err) {
      console.error('Authentication error:', err);
      setError(err.message || 'Error al iniciar sesión con Google');
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleError = () => {
    setError('Error al conectar con Google. Intenta nuevamente.');
  };

  return (
    <div className="google-signin-wrapper">
      {error && <p className="login-error">{error}</p>}
      {isLoading ? (
        <div className="login-loading">
          <div className="loading-spinner"></div>
          <span>Verificando acceso...</span>
        </div>
      ) : (
        <GoogleLogin onSuccess={handleGoogleSuccess} onError={handleGoogleError} />
      )}
    </div>
  );
};

export default SignIn;
